import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import NextRouter from 'next/router'
import { getUserPackage } from 'SRC/modules/users/Profile/selectors'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { setUserPackageInactiveMsg } from 'SRC/modules/users/Profile/actions'
import { Form, ChoiceCategoryPage } from '../components'

class Router extends React.Component {
  componentDidMount () {
    const { setUserPackageInactiveMsg } = this.props

    if (!this.checkPackage()) {
      setUserPackageInactiveMsg('Vaš paket je istekao ili nije aktivan. Za više informacija pozovite: 067/312-555 ili 067/313-555')
      NextRouter.push('/index', '/')
    }
  }

  checkPackage = () => {
    const { userPackage, isAuthorized } = this.props

    return Boolean(!isAuthorized || (userPackage && userPackage.activated && !userPackage.expired))
  }

  getRenderComponent = () => {
    const { category } = this.props

    if (!category) return ChoiceCategoryPage

    return Form
  }

  render () {
    const Component = this.getRenderComponent()

    return (
      <Component
        category={this.props.category}
      />
    )
  }
}

Router.propTypes = {
  category: PropTypes.string,
  userPackage: PropTypes.shape({
    activated: PropTypes.string,
    expired: PropTypes.bool
  }),
  isAuthorized: PropTypes.bool.isRequired,
  setUserPackageInactiveMsg: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  return {
    userPackage: getUserPackage(state),
    isAuthorized: getIsAuthorized(state)
  }
}

export default connect(mapStateToProps, { setUserPackageInactiveMsg })(Router)
